import { atom } from 'jotai';
export const placeListFilterAtom = atom({
    sortOption: null,
    scoreUnder: null,
    hasSlope: null,
    isRegistered: null,
});
export const placeListFilterModalStateAtom = atom(null);
